import "@fortawesome/fontawesome-free/css/all.min.css";
import { Box, Button } from "@mui/material";

interface Props {
	handleExportToExcel: () => void;
	disabled?: boolean;
	label?: string;
	size?: "small" | "medium" | "large";
	fullWidth?: boolean;
}

export const ExcelButton = ({
	handleExportToExcel,
	disabled,
	label = "Excel",
	size = "medium",
	fullWidth = true,
}: Props) => {
	return (
		<Button
			size={size}
			variant="outlined"
			disabled={disabled}
			onClick={handleExportToExcel}
			startIcon={
				<Box
					component="i"
					className="far fa-file-excel"
					sx={{ color: "success.main" }}
				/>
			}
			fullWidth={fullWidth}
			data-test-id="export-excel-button"
			sx={{
				backgroundColor: "background.paper",
				borderColor: "divider",
				color: "text.secondary",
				fontWeight: 500,
				textTransform: "none",
				"&:hover": {
					backgroundColor: "action.hover",
					borderColor: "text.disabled",
				},
				"&.Mui-disabled .MuiButton-startIcon": { color: "inherit" },
			}}
		>
			{label}
		</Button>
	);
};
